import {
  REQUEST_UPPERBOUND,
  NUMBER_OF_NEXT_ITINERARIES,
} from '../../constants/constants'

export function getPageNumber({ itinerariesIndex }) {
  const INITIAL_PAGE_NUMBER = 1

  // we load the REQUEST_UPPERBOUND number of itineraries initially
  // and then NUMBER_OF_NEXT_ITINERARIES more on each subsequent load

  return Math.ceil(
    (itinerariesIndex - REQUEST_UPPERBOUND) / NUMBER_OF_NEXT_ITINERARIES +
      INITIAL_PAGE_NUMBER
  )
}
